import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
} from "recharts";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Mongotest from "./Mongotest";
import SalesPerform from "./SalesPerform";

interface TrafficEntry {
  LogDate: string;
  SiteName: string;
  BytesSent: number;
  BytesReceived: number;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TrafficDashboard />} />
        <Route path="/mongotest" element={<Mongotest />} />
        <Route path="/salesperform" element={<SalesPerform />} />
      </Routes>
    </BrowserRouter>
  );
}

function TrafficDashboard() {
  const [groupedData, setGroupedData] = useState<Record<string, TrafficEntry[]>>({});

  useEffect(() => {
    axios
      .get("https://pdawebsvrtest.dahaeinc.co.kr/ZETC/GetLogs")
      .then((res) => {
        const filtered = res.data.filter(
          (entry: TrafficEntry) => entry.BytesSent > 0 || entry.BytesReceived > 0
        );

        const grouped: Record<string, TrafficEntry[]> = {};
        filtered.forEach((entry: TrafficEntry) => {
          if (!grouped[entry.LogDate]) grouped[entry.LogDate] = [];
          grouped[entry.LogDate].push(entry);
        });

        setGroupedData(grouped);
      })
      .catch((err) => console.error("Failed to fetch traffic:", err));
  }, []);

  return (
    <div className="p-6 space-y-6">
      <h1 className="text-3xl font-bold">📊 IIS Daily Traffic Dashboard</h1>

      {Object.keys(groupedData).sort((a, b) => b.localeCompare(a)).map((date) => (
        <div key={date}>
          <h2 className="text-xl font-semibold mb-2">📅 {date}</h2>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={groupedData[date]}
              margin={{ top: 20, right: 30, left: 20, bottom: 100 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="SiteName"
                angle={-45}
                textAnchor="end"
                interval={0}
                height={120}
              />
              <YAxis
                tickFormatter={(v) => `${(v / 1024 / 1024).toFixed(1)} MB`}
              />
              <Tooltip
                formatter={(value: number) => `${(value / 1024 / 1024).toFixed(2)} MB`}
              />
              <Legend />
              <Bar dataKey="BytesSent" fill="#8884d8" name="Sent (Bytes)" />
              <Bar dataKey="BytesReceived" fill="#82ca9d" name="Received (Bytes)" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      ))}
    </div>
  );
}
